// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3wOeC","consentsList":"PatientConsents_consentsList__RAgXK","consentsListEmpty":"PatientConsents_consentsListEmpty__2m7JS"};